import { types } from 'mobx-state-tree';

const Term = types.model({
  id: types.maybeNull(types.number),
  startDate: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
});

export default Term;
